import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai"; // React icon for close
import { Link } from "react-router-dom";
import "tailwindcss/tailwind.css"; // Import Tailwind CSS if it's not already globally available

const OrderCompletePopup = ({ orderData }) => {
  const [showPopup, setShowPopup] = useState(true); // State to toggle the popup visibility

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && (
        <div className="fixed inset-0 flex  justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 mr-3 rounded-lg shadow-lg w-[70%] sm:w-[70%]  lg:w-[600px] h-[300px] sm:h-[300px] lg:h-[300px] relative">
            <button
              className="absolute top-2 right-2 font-bold text-white bg-[#AF313D] rounded-full w-6 h-6 flex items-center justify-center"
              onClick={closePopup}
            >
              <AiOutlineClose />
            </button>

            {/* Order ID Section with Justified Text */}
            <div className="flex gap-2 items-center mb-4 mt-8 px-5">
              <h2 className="text-[15.38px] sm:text-[15.38px] lg:text-[30px] font-semibold">
                Order ID:
              </h2>
              <p className="text-[9.38px] sm:text-[8.38px] lg:text-[20px] font-semibold text-right">
                {orderData?.data._id?.slice(-6)}
              </p>
            </div>

            {/* Reward Point Section with Justified Text */}
            {/* <div className="flex justify-between items-center mb-4">
              <h2 className="text-[18.38px] sm:text-[18.38px] lg:text-[30px] font-semibold">
                Reward Point:
              </h2>
              <p className="text-[14.38px] sm:text-[10.38px] lg:text-[20px] font-semibold text-right">
               {orderData?.data.cashbackPoints}
              </p>
            </div> */}
            <div className="flex items-center justify-center text-center font-baloo font-medium text-[16px] sm:text-[16px] sm:mt-8 mt-8">
              {/* <p>Congratulation! You have received 100% cashback</p> */}
            </div>
            <div className="flex flex-wrap justify-center items-center gap-5 mt-5 mx-2 md:mx-0">
              <Link to="/wallet">
                <button className="bg-[#AF313D] sm:w-[125.64px] sm:h-[25.47px] w-[100.64px] h-[25.47px] lg:w-[150px] lg:h-[42px] text-white rounded-full capitalize">
                  go to Wallet
                </button>
              </Link>
              <Link to={`/order-status-order/${orderData?.data._id}`}>
                <button className="bg-[#AF313D] sm:w-[125.64px] sm:h-[25.47px] w-[100.64px] h-[25.47px] lg:w-[200px] lg:h-[42px] text-white rounded-full capitalize">
                view order details
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderCompletePopup;
